import React, { useState, useEffect,useRef } from "react";
import { FaUser, FaCheck } from "react-icons/fa";
import { MdGroup } from "react-icons/md";
import { getTomadores, getUtilizadores } from "../services/Contacts";
import { editarChat } from "../services/chat";
import { useAuth } from "../context/AuthContext";
import { styles } from "../styles/GroupDetails.styles"; 
import { IoMdRemoveCircleOutline,IoMdPersonAdd   } from "react-icons/io";
import { useSocket } from "../context/SocketContext";
import { formatDate,arrayBufferToBase64 } from "../utils/utils";
import { FaUserShield  } from "react-icons/fa6";
import { getProfile } from "../services/profile";


function GroupDetails({ 
  isOpen, 
  onClose, 
  participants, 
  isMobile, 
  socket, 
  onAddSelected, 
  conversationData,
  isAdmin,
  hasTomador 
}) {
  const { token, stampTomador } = useAuth(); 
  const conversationId = conversationData?.STAMP;
  const [tomadores, setTomadores] = useState([]);
  const [utilizadores, setUtilizadores] = useState([]);
  const [perfil, setPerfil] = useState({ NOME: "", FOTO: null });
  const [openMenuStamp, setOpenMenuStamp] = useState(null);
  const [localName, setLocalName] = useState(conversationData?.NOME || "");
  const [localLogo, setLocalLogo] = useState(conversationData?.LOGO || null);
  const isPrivate = conversationData?.TIPO === "private";
  const [hasChanges, setHasChanges] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [hover, setHover] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const menuRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState(null);
  const [limit] = useState(20);
  const [beforeTomadores, setBeforeTomadores] = useState(null);
  const [hasMoreTomadores, setHasMoreTomadores] = useState(true);
  const [loadingMoreTomadores, setLoadingMoreTomadores] = useState(false);
  const [beforeUtilizadores, setBeforeUtilizadores] = useState(null);
  const [hasMoreUtilizadores, setHasMoreUtilizadores] = useState(true);
  const [loadingMoreUtilizadores, setLoadingMoreUtilizadores] = useState(false);
  const mergedParticipants = [
    ...tomadores,
    ...utilizadores
  ];

  const fetchProfile = async () => {
    try {
      const data = await getProfile();
      setPerfil({ NOME: data.NOME, FOTO: data.FOTO });
    } catch (err) {
      console.error("Erro ao buscar perfil:", err);
    }
  };

  const fetchTomadores = async (reset = false) => {
  try {
    const data = await getTomadores(
      conversationId,
      limit,
      reset ? null : beforeTomadores
    );

    const newItems = Array.isArray(data) ? data : [];

    setTomadores((prev) => {
      const merged = reset ? newItems : [...prev, ...newItems];

      const map = new Map();
      for (const t of merged) {
        map.set(t.STAMP, t);
      }

      return Array.from(map.values());
    });

    setHasMoreTomadores(newItems.length === limit);

    if (newItems.length > 0) {
      setBeforeTomadores(newItems[newItems.length - 1].STAMP);
    }
  } catch (err) {
    console.error("Erro tomadores:", err);
  }
};

const fetchUtilizadores = async (reset = false) => {
  try {
    const data = await getUtilizadores(
      conversationId,
      limit,
      reset ? null : beforeUtilizadores
    );

    const newItems = Array.isArray(data) ? data : [];

    setUtilizadores((prev) => {
      const merged = reset ? newItems : [...prev, ...newItems];

      const map = new Map();
      for (const u of merged) {
        map.set(u.STAMP, u);
      }

      return Array.from(map.values());
    });

    setHasMoreUtilizadores(newItems.length === limit);

    if (newItems.length > 0) {
      setBeforeUtilizadores(newItems[newItems.length - 1].STAMP);
    }
  } catch (err) {
    console.error("Erro utilizadores:", err);
  }
};

  
  const handleScroll = (e) => {
    const el = e.target;

    if (el.scrollTop + el.clientHeight < el.scrollHeight - 20) return;

    if (loadingMoreTomadores || loadingMoreUtilizadores) return;

    if (hasMoreUtilizadores) {
      fetchUtilizadores(false);
    } else if (hasMoreTomadores) {
      fetchTomadores(false);
    }
};


  

  useEffect(() => {
    if (!token || !conversationId) return;

    fetchProfile();
    fetchTomadores(true);
    fetchUtilizadores(true);
}, [token, conversationId]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      const isInsideMenu = event.target.closest("[data-participant-menu]");
      
      if (!isInsideMenu) {
        setOpenMenuStamp(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


    useEffect(() => {
        setLocalName(conversationData?.NOME || "");
        setLocalLogo(conversationData?.LOGO || null);
        setHasChanges(false);
  }, [conversationData]);


  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const img = new Image();
  const reader = new FileReader();

  reader.onload = (event) => {
    img.src = event.target.result;
  };

  img.onload = () => {
    const canvas = document.createElement("canvas");

    const maxSize = 512;

    let { width, height } = img;

    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }

    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);

    const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7);

    setLocalLogo(compressedBase64);
    setHasChanges(true);
  };

  reader.readAsDataURL(file);
};

  const handleNameChange = (e) => {
    setLocalName(e.target.value);
    setHasChanges(true);
  };

  const handleSave = async () => {
    setIsSaving(true);

    conversationData.NOME = localName;
    conversationData.LOGO = localLogo;

    try {
      const resultado = await editarChat({
        token,
        chatstp: conversationId,
        nomeGrupo: localName,
        fotogrupo: localLogo
      });

      if (resultado) {
        setHasChanges(false);
      }
    } catch (error) {
      console.error("Erro ao guardar chat:", error);
    } finally {
      setIsSaving(false);
    }
  };


  if (!isOpen) return null;

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        
       {/* Header */}
       <div style={styles.header}>
            <button onClick={onClose} style={styles.closeButton}>✕</button>
         
            <div
              style={{ position: "relative", width: 80, height: 80, borderRadius: "50%", overflow: "hidden" }}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              {localLogo ? (
                <img
                  src={localLogo}
                  alt={localName}
                  style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#ccc",
                    borderRadius: "50%",
                  }}
                >
                  <MdGroup size={isMobile ? 40 : 50} color="#666" />
                </div>
              )}

              {isAdmin && !isPrivate && hover && (
                <label
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    color: "#fff",
                    fontSize: isMobile ? 12 : 14,
                    textAlign: "center",
                  }}
                >
                  Alterar fotografia
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none"}}
                    onChange={handleFileChange}
                  />
                </label>
              )}
            </div>


           {isEditing ? (
            <input
              type="text"
              value={localName}
              onChange={handleNameChange}
              onBlur={() => setIsEditing(false)}
              style={{ fontSize: 18, width: '80%', marginTop :"2%" }}
            />
          ) : (
            <h2
              style={styles.groupTitle}
              onClick={() => isAdmin &&  !isPrivate && setIsEditing(true)}
            >
              {localName || "Grupo sem nome"}
            </h2>
          )}
        </div>

        <h4 style={{ width: "100%", marginTop: 16, marginBottom: 8, fontSize: 16, color: "#333", textAlign: "left" }}>
            Participantes
        </h4>

        {/* Lista de participantes na vertical */}
        <div style={styles.participantsList} onScroll={handleScroll}>
            {participants.map((p) => {
                const handleRemove = () => {

                socket.emit("removeParticipant", {
                    chatstp: conversationId,
                    nome: p.NOME,
                    stamp: p.STAMP,
                });

                setOpenMenuStamp(null); 
                };

                const handleAdmin = () => {

                socket.emit("addAdmin", {
                    chatstp: conversationId,
                    stamp: p.STAMP,
                    nome: p.NOME
                });

                setOpenMenuStamp(null); 
                };

                return (
                <div key={p.STAMP || p.NOME} style={styles.participant}>
                    <div style={styles.participantIcon}>
                     <div
                        style={{
                          width: 30,
                          height: 30,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "50%",
                          overflow: "hidden",
                     
                        }}
                      >


                    {p.FOTO ? (
                            <img
                              src={p.FOTO}
                              alt={p.NOME}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                    ) : p.TIPO === "TM" ? (
                                <FaUserShield   size={isMobile ? 16 : 20} color="#fff" />
                            ) : (
                                <FaUser size={isMobile ? 16 : 20} color="#fff" />
                            )}
                   
                    </div>
                 </div>    
                    <span style={styles.participantName}>{p.NOME}</span>

                    {/* Três pontinhos do lado direito */}
                    {(
                        (isAdmin && hasTomador) ||
                        (isAdmin && !hasTomador && !isPrivate)
                      ) && p.NOME !== perfil.NOME && (
                      <div style={{ marginLeft: "auto", position: "relative" }}>
                        <button
                            style={styles.participantMenuButton}
                            onClick={(e) =>{
                               e.stopPropagation();
                               const rect = e.currentTarget.getBoundingClientRect();
                               
                                setMenuPosition({
                                  top: rect.bottom + 4,
                                  left: rect.left - 160 + rect.width,
                                });

                            setOpenMenuStamp(openMenuStamp === p.STAMP ? null : p.STAMP)
                            }
                              
                            }
                        >
                            ⋮
                        </button>

                        {openMenuStamp === p.STAMP && p.NOME !== perfil.NOME && (
                            <div 
                            data-participant-menu
                            style={{
                              ...styles.participantDropdown,
                              top: menuPosition?.top,
                              left: menuPosition?.left
                            }}
                            onClick={(e) => e.stopPropagation()}
                            
                            >
                            <div
                                style={styles.participantDropdownItem}
                                onClick={handleRemove}
                            >
                            <IoMdRemoveCircleOutline  style={{ marginRight: 6 }} />    
                            Remover
                            </div>


                            {p.TIPO !== "TM" && (
                            <div
                                style={styles.participantDropdownItem}
                                onClick={handleAdmin}
                              >
                                <IoMdPersonAdd style={{ marginRight: 6 }} />    
                                Tornar Admin
                              </div>
                            )} 
                            </div>                          
                        )}
                      </div>
                    )}
                </div>
                );
            })}
        </div>

         {hasChanges && (
           <div style={styles.actionButtons}>
                   <button onClick={handleSave} style={styles.button(true, isSaving)} disabled={isSaving}>
                    {isSaving ? (
                      <>
                        <div style={{ width: 16, height: 16, border: "2px solid #fff", borderTop: "2px solid transparent", borderRadius: "50%", marginRight: 6, animation: "spin 0.8s linear infinite" }} />
                        A guardar...
                      </>
                    ) : (
                      <>
                        <FaCheck style={{ marginRight: 6 }} />
                        Guardar Alterações
                      </>
                    )}
                  </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default GroupDetails;